import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';

import moment from 'moment-timezone';
import { switchMap } from 'rxjs';
import { startWith } from 'rxjs/operators';

import {
  ConnectedOverlayDirective,
  DatePickerComponent,
  DropdownComponent,
  InputComponent,
  OverlayOriginDirective,
} from '@recruitee/user-interface';

import { DynamicDatePickerInputConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class DatePickerInput extends DynamicFormInput<DynamicDatePickerInputConfig> {}

@Component({
  selector: 'rti-date-picker-input',
  templateUrl: './date-picker-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ConnectedOverlayDirective,
    DatePickerComponent,
    DropdownComponent,
    InputComponent,
    OverlayOriginDirective,
    ReactiveFormsModule,
  ],
})
export class DatePickerInputComponent {
  public input = input.required<DatePickerInput>();

  public dropdownOpen = signal<boolean>(false);
  public inputValue = signal<string | null>(null);

  public isDateDisabled = computed(() => {
    const { maxDate } = this.input().config;
    return maxDate ? (date: moment.Moment) => date.isAfter(moment(maxDate)) : () => false;
  });

  private watchInputValue = toObservable(this.input)
    .pipe(
      switchMap(({ control }) => control.valueChanges.pipe(startWith(control.value))),
      takeUntilDestroyed(),
    )
    .subscribe(value => this.inputValue.set(value));

  public toggleDropdown(nextState?: boolean): void {
    this.dropdownOpen.update(currentState => nextState ?? !currentState);
  }
}
